import { api } from '../api';
import type { Tab } from '../types';

export const createTab = (tabData: Omit<Tab, 'id' | 'createdAt'>) => api.tabs.create({ ...tabData, isComplete: false });
export const joinTab = (tabId: string, userId: string) => api.tabs.join(tabId, userId);
export const updateTab = (id: string, tabData: Partial<Tab>) => api.tabs.update(id, tabData);
export const deleteTab = (id: string) => api.tabs.delete(id);
export const getTabById = (id: string) => api.tabs.getById(id);
export const getUserTabs = (userId: string) => api.tabs.getUserTabs(userId);
export const subscribeToTab = (id: string, callback: (tab: Tab | null) => void) => api.tabs.subscribe(id, callback);
export const subscribeToUserTabs = (userId: string, callback: (tabs: Tab[]) => void) => api.tabs.subscribeUserTabs(userId, callback);
